import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import './../genFields.css';

class SelectField extends React.Component {
    render() {
        const {
            input,
            options,
            placeholder,
            disabled,
            intl,
            hideErrors,
            id,
            meta: { touched, error, warning }
        } = this.props;
        let placeholderContent = typeof placeholder === 'string' ? placeholder : intl.formatMessage(placeholder);

        if (disabled) {
            let content = options && input.value ? options.find(o => o.value === input.value) : input.value;
            return (
                <div className="text-field">
                    <div className="field-placeholder">{placeholderContent}</div>
                    <span className="disabled-input">{content && content.label ? content.label : input.value}</span>
                    <span className="validation-message" />
                </div>
            );
        }

        return (
            <div className="select-field">
                {input.value && <div className="field-placeholder">{placeholderContent}</div>}
                <select {...input} id={id ? id : ''} className={`form-control col-xs-12 ${input.value && input.value !== '' ? '' : 'not-selected'}`}>
                    <option value="" default disabled>
                        {placeholderContent}
                    </option>
                    {options.map((option, i) => {
                        return (
                            <option key={i} value={option.value}>
                                {option.label}
                            </option>
                        );
                    })}
                </select>
                {hideErrors === undefined && <span className="validation-message">{touched && (error || warning)}</span>}
            </div>
        );
    }
}

SelectField.defaultProps = {
    placeholder: '',
    options: [],
    meta: {},
    input: {}
};

SelectField.propTypes = {
    placeholder: PropTypes.any,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string | PropTypes.number,
            label: PropTypes.string | PropTypes.object
        })
    ).isRequired,
    meta: PropTypes.object,
    input: PropTypes.object
};

export default injectIntl(SelectField);



// WEBPACK FOOTER //
// ./src/components/genFields/select/index.jsx